import React from "react";
import GetSvgIcon, {
  GetSvgBuilding,
  GetSvgPerson,
  GetSvgPhone,
} from "../../../images/svglist";
import { Col, Row } from "react-bootstrap";
import {
  CH_SRVC_TYPE,
  INFO_CODE,
  ORDER_TYPE,
  PARTICULAR,
} from "../../../ConfigConstants/ConfigConstants";
import moment from "moment";
import {
  DATE_FORMAT_CLIENT,
  DATE_FORMAT_MOMENT,
  DATE_FORMAT_SERVER,
} from "../../Helper/Constants";
import { useForm } from "react-hook-form";

const CharterOrderSummary = ({
  getValues,
  rate,
  insuranceData,
  custCreditInfo,
  watch,
  setValue,
}) => {
  const useCredit = watch("useCredit");
  const creditBalance = -custCreditInfo?.payment_due;
  const rateType = getValues("rateType");
  // setValue("creditNotes", -custCreditInfo?.payment_due);
  const totalIncludingSST =
    (!!getValues("totalAmt") ? +getValues("totalAmt") : 0.0) +
    (!!getValues("sst") ? +getValues("sst") : 0.0);
  let totalToPay;
  if (useCredit) {
    totalToPay =
      creditBalance >= totalIncludingSST
        ? 0
        : totalIncludingSST - creditBalance;
  }
  const renderRouteStops = (key, label) => (
    <Col md={6} className="grd-bg p-2 p my-2 rounded-3">
      <div className="fw-bold">{label}</div>
      <div className="theme-blue-txt">
        <span className="theme-blue-txt">{GetSvgPerson(false)}</span>{" "}
        {getValues(`${key}.name`)}
      </div>
      <div className="theme-blue-txt font-12 mt-2">
        <span className="theme-blue-txt me-2">{GetSvgPhone(false)}</span>
        {getValues(`${key}.phone`)}
      </div>
      <div className="theme-blue-txt d-flex mt-2">
        <span className="theme-blue-txt me-2">{GetSvgBuilding(false)}</span>

        <div className="font-12">
          {getValues(`${key}.address`) +
            ", " +
            getValues(`${key}.city`) +
            ", " +
            getValues(`${key}.state`) +
            ", " +
            getValues(`${key}.postcode`)}
        </div>
      </div>
      <div className="theme-blue-txt d-flex mt-2">
        <span className="theme-blue-txt me-2">
          {GetSvgIcon("BiGeoAltFillDanger")}
        </span>
        <div className="font-12">
          {getValues(`${key}.latitude`) + ", " + getValues(`${key}.longitude`)}
        </div>
      </div>
    </Col>
  );

  const getFareLabelValue = (service) => {
    switch (service?.serviceId) {
      case 0:
        return [service?.serviceText, service?.charges];
      case CH_SRVC_TYPE.WEIGHT:
      case CH_SRVC_TYPE.EXTRAMANPOWER:
        return [
          `${service?.serviceType} (@ ${service.serviceUnitPrice} RM)`,
          !!service.serviceValue
            ? service?.serviceUnitPrice * service?.serviceValue
            : 0,
        ];
      case CH_SRVC_TYPE.VHCLTYPE:
      case CH_SRVC_TYPE.OTHERCHRG:
        return [`${service?.rateRefName}`, service?.charges];
      case CH_SRVC_TYPE.PIECES:
        return [
          `${service?.unitTypeText} (@ ${service.charges} RM)`,
          !!service.serviceValue
            ? service?.serviceUnitPrice * service?.serviceValue
            : 0,
        ];
      case CH_SRVC_TYPE.TAILGATE:
        return [service?.serviceType, service.charges];
      default:
        return ["", 0];
        break;
    }
  };

  const renderRate = (rowNo, service) => {
    const fare = getFareLabelValue(service);
    return (
      <Row className="mb-1 px-0">
        <Col md={7} className="text-start align-middle">
          <label className="form-label mb-0 align-middle">{fare[0]}</label>
        </Col>
        <Col md={4} className="text-end">
          <input className="form-control" readOnly value={fare[1]} />
        </Col>
        <Col md={1} className="text-start align-middle px-0">
          <label className="form-label mb-0 align-middle">RM</label>
        </Col>
      </Row>
    );
  };

  const renderBill = (bill) => {
    return (
      <Row className="mb-1 px-0">
        <Col md={7} className="text-start align-middle">
          <label className="form-label mb-0 align-middle">
            {bill?.particular}
          </label>
        </Col>
        <Col md={4} className="text-end">
          <input
            className="form-control"
            readOnly
            value={bill?.totalBillAmount?.toFixed(2)}
          />
        </Col>
        <Col md={1} className="text-start align-middle px-0">
          <label className="form-label mb-0 align-middle">RM</label>
        </Col>
      </Row>
    );
  };

  const getServiceLabel = (rate) => {
    switch (rate.serviceId) {
      case CH_SRVC_TYPE.TAILGATE:
        return ["Tail Gate", rate.isServiceEnabled && "Yes"];
      case CH_SRVC_TYPE.OTHERCHRG:
        return [rate.rateRefName, rate.isServiceEnabled && "Yes"];
      case CH_SRVC_TYPE.VHCLTYPE:
        return ["Vehicle Type", rate.rateRefName];
      case CH_SRVC_TYPE.PIECES:
        return [rate.unitTypeText, rate.serviceValue];
      default:
        return [rate.serviceType, rate.serviceValue];
    }
  };

  return (
    <div>
      <div className="text-danger fw-bold fst-italic">
        * Please make sure the order details are correct before proceeding{" "}
      </div>
      <Row className="px-4">
        <Col md={8}>
          <Row>
            {getValues("orderType") === ORDER_TYPE.CHP && (
              <Col md={4} className="grd-bg p-2 p my-2 rounded-3">
                <div className="fw-bold">Route</div>
                <div className="theme-blue-txt">
                  <span className="text-info">
                    {GetSvgIcon("BiGeoAltFillDanger")}
                  </span>{" "}
                  {getValues("route.routeCode")}
                </div>
              </Col>
            )}

            <Col md={4} className="grd-bg p-2 p my-2 rounded-3">
              <div className="fw-bold">Pickup Date</div>
              <div className="theme-blue-txt">
                <span className="text-success">
                  {GetSvgIcon("CalenderIcon")}
                </span>{" "}
                {moment(
                  getValues("shipmentDate"),
                  DATE_FORMAT_SERVER,
                  true
                ).format(DATE_FORMAT_MOMENT)}{" "}
                {getValues("shipmentTime")}
              </div>
            </Col>
            <Col md={4} className="grd-bg p-2 p my-2 rounded-3">
              <div className="fw-bold">Delivery Date</div>
              <div className="theme-blue-txt">
                <span className="text-success">
                  {GetSvgIcon("CalenderIcon")}
                </span>{" "}
                {moment(
                  getValues("estDeliveryDate"),
                  DATE_FORMAT_SERVER,
                  true
                ).format(DATE_FORMAT_MOMENT)}
              </div>
            </Col>
          </Row>
          <Row>
            {renderRouteStops("route.origin", "Origin")}
            {renderRouteStops("route.destination", "Destination")}
            {getValues("route.stops").length > 0 &&
              getValues("route.stops").map(
                (st, index) =>
                  ![0, 99].includes(st.stopSeq) &&
                  st.isChecked === true &&
                  renderRouteStops(`route.stops.${index}`, `Stop ${index + 1}`)
              )}
          </Row>
          <Row>
            <Col md={6} className="grd-bg p-2 my-2 rounded-3">
              <div className="fw-bold">Rate Type </div>
              <div className="theme-blue-txt">
                <span className="text-success">
                  {GetSvgIcon("CalenderIcon")}
                </span>{" "}
                {
                  getValues("rateTypeOpts")?.find(
                    (opt) => opt.value === +getValues("route.rateType")
                  )?.label
                }
              </div>
            </Col>
            {/* </Row>
          <Row> */}
            <Col md={6} className="grd-bg p-2 p my-2 rounded-3">
              {getValues("vas")?.map((rt) => {
                const [label, value] = getServiceLabel(rt);
                return (
                  <>
                    {![0, 768, 777].includes(rt.serviceId) && (
                      <Row>
                        <Col>
                          <span className="fw-bold">{label}: </span>
                          <span className="theme-blue-txt">{value}</span>
                        </Col>
                      </Row>
                    )}
                  </>
                );
              })}
            </Col>
          </Row>
          {/* <div>
            <span className="border-bottom font-18 border-3">
              Protection Info
            </span>
          </div> */}
          <Row>
            <Col className="grd-bg rounded-3 p-2 my-2">
              <Row className="ps-1">
                <Col className="px-2">
                  <div className="fw-bold">Item Name</div>
                </Col>
                <Col className="px-2">
                  <div className="fw-bold">Item Type</div>
                </Col>
                <Col md={2} className="px-2">
                  <div className="fw-bold">Item Quantity</div>
                </Col>
              </Row>
              {getValues("orderInfos")
                .filter((info) => info.infoCode === INFO_CODE.CH)
                .map((item) => (
                  <Row className="ps-1">
                    <Col className="ps-2">
                      <div className="theme-blue-txt">{item?.infoValue}</div>
                    </Col>
                    <Col className="ps-2">
                      <div className="theme-blue-txt">{item?.infoType}</div>
                    </Col>
                    <Col md={2} className="ps-2">
                      <div className="theme-blue-txt">{item?.infoQuantity}</div>
                    </Col>
                  </Row>
                ))}
            </Col>
          </Row>
          <Row>
            <Col md={6} className="grd-bg p-2 my-2 rounded-3">
              <div className="fw-bold">Remarks</div>
              <div className="theme-blue-txt">{getValues("remark")}</div>
            </Col>
          </Row>

          {insuranceData
            ?.filter((ins) => ins.insuranceId === getValues("insurancePkgId"))
            .map((ins) => (
              <Row>
                <Col className=" grd-bg my-2 p-2 rounded-3">
                  <div className="fw-bold">Package Id</div>
                  <div className="theme-blue-txt">{ins?.packageId}</div>
                </Col>
                <Col className=" grd-bg my-2 p-2 rounded-3">
                  <div className="fw-bold">Coverage Upto</div>
                  <div className="theme-blue-txt">RM {ins?.coverage}</div>
                </Col>
                <Col className=" grd-bg my-2 p-2 rounded-3">
                  <div className="fw-bold">Insurance Fee</div>
                  <div className="theme-blue-txt">RM {ins?.price}</div>
                </Col>
                <Col className=" grd-bg my-2 p-2 rounded-3">
                  <div className="fw-bold">Insurance Declared Price</div>
                  <div className="theme-blue-txt">
                    {getValues("insDeclaredPrice")
                      ? "RM " + getValues("insDeclaredPrice")
                      : ""}
                  </div>
                </Col>
              </Row>
            ))}
          <Row>
            {getValues("orderInfos")
              .filter((info) => info.infoCode === INFO_CODE.SPCLPERM)
              .map((info) => (
                <Col md={4} className="grd-bg p-2 my-2 rounded-3">
                  <div className="fw-bold">
                    Special permission {info?.infoValue}
                  </div>
                  <div className="theme-blue-txt">YES</div>
                </Col>
              ))}
          </Row>
        </Col>
        <Col md={4}>
          {getValues("orderType") === ORDER_TYPE.CHP && (
            <Row className="filled-view-blue">
              <Col>
                <Row className="mb-1 px-0">
                  <span className="mb-2">Fare Summary</span>
                </Row>
                {/* {getValues("route.rateBase")?.length > 0 &&
                JSON.parse(getValues("route.rateBase")).map((rt, index) =>
                  renderRate(index + 1, rt)
                )}
              {getValues("vhclTypeRate")?.length > 0 &&
                getValues("vhclTypeRate")?.map((vt, index) =>
                  renderRate(index, vt)
                )}
              {getValues("rate").map((rt, index) => renderRate(index, rt))} */}
                {getValues("shipmentBilling").map((bill, index) => {
                  if (bill.particularId !== PARTICULAR.SST) {
                    return renderBill(bill);
                  }
                })}
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                {renderBill({
                  particular: "Sub Total (Excluding SST)",
                  totalBillAmount: !!getValues("totalAmt")
                    ? +getValues("totalAmt")
                    : 0.0,
                })}
                {renderBill({
                  particular: "SST",
                  totalBillAmount: !!getValues("sst") ? +getValues("sst") : 0.0,
                })}
                {renderBill({
                  particular: "Total (Including SST)",
                  totalBillAmount:
                    (!!getValues("totalAmt") ? +getValues("totalAmt") : 0.0) +
                    (!!getValues("sst") ? +getValues("sst") : 0.0),
                })}
                {rateType === 763 && (
                  <>
                    {/* <Row className="mt-2">
                      <Col md={7} className="text-start align-middle">
                        <input
                          type="checkbox"
                          id="useCredit"
                          className="me-2"
                          onClick={(e) =>
                            setValue("useCredit", e.target.checked)
                          }
                        />
                        <label className="form-label mb-0 align-middle">
                          Apply Available Credit Balance:
                        </label>
                      </Col>
                      <Col md={4} className="text-end">
                        <input
                          className="form-control"
                          readOnly
                          value={creditBalance}
                        />
                      </Col>
                      <Col md={1} className="text-start align-middle px-0">
                        <label className="form-label mb-0 align-middle">
                          RM
                        </label>
                      </Col>
                    </Row> */}

                    {useCredit && (
                      <Row className="mt-2">
                        <Col md={7} className="text-start align-middle">
                          <label className="form-label mb-0 fw-bold">
                            Total Amount to Pay:
                          </label>
                        </Col>
                        <Col md={4} className="text-end">
                          <input
                            className="form-control text-start"
                            readOnly
                            value={totalToPay.toFixed(2)}
                          />
                        </Col>
                        <Col md={1} className="text-start align-middle px-0">
                          <label className="form-label mb-0">RM</label>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CharterOrderSummary;
